import React, { useContext } from "react";

import { OrderListingContext } from "../listing/context/OrderListingContext";
import { OrderListingItem } from "../listing/OrderListingItem";
import { RejectOrderModal } from "./RejectOrderModal";

type RejectOrderListingDialogProps = {
    item: OrderListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const RejectOrderListingDialog: React.VFC<RejectOrderListingDialogProps> = ({
    isOpen,
    item,
    onClose
}: RejectOrderListingDialogProps) => {
    const { reject } = useContext(OrderListingContext);

    const handleReject = async () => {
        reject(item.id);

        onClose();
    };

    return <RejectOrderModal isOpen={isOpen} onCancel={onClose} onSubmit={handleReject} orderId={item.id} />;
};
